<template>
    <div class="container">
        <el-bread-cumb :bread-cumb="breadCumb"></el-bread-cumb>
        <div class="warp50">
            <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px">
                <el-form-item label="用户组:" prop="group_ids">
                    <div v-for="group in groups">
                        <p class="bold">{{group.category_name}}</p>
                        <el-checkbox-group v-model="userForm.group_ids">
                            <el-checkbox v-for="item in group.group" :label="item.group_id" :key="item.group_id" :checked="item.checked">{{item.title}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="submitForm('userForm')">添加</el-button>
                    <el-button @click="resetForm('userForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import ElBreadCumb from '../../../components/BreadCumb.vue'

    export default {
        components: { ElBreadCumb },
        data() {
            var checkGroup = (rule, value, callback) => {
                if (value.length == 0) {
                    return callback(new Error('请选择用户组'));
                }
                callback();
            };
            return {
                loading: false,
                userForm: {
                    user_id: '',
                    group_ids: [],
                },
                groups: [],
                rules: {}
            };
        },
        created (){
            this.userForm.user_id = this.$route.params.id;
            //获取用户权限
            let params = {user_id: this.userForm.user_id};
            this.$api.get(this.$apiUrl.relateAuthGroup,params,(res)=>{
                this.groups = res.data;
            })
        },
        computed: {
            breadCumb: function(){
                return [{'name':'管理员管理','path':`/user/list/${this.$route.params.ruleId}`},{'name':'关联组','path':''}]
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        for(let i in this.groups){
                            for(let j in this.groups[i]){
                                if(this.groups[i][j].checked){
                                    this.userForm.group_ids.push(this.groups[i][j]);
                                }
                            }
                        }
                        this.userForm.group_ids = this.userForm.group_ids.join(',');
                        this.loading = true;
                        this.$api.post(this.$apiUrl.relateAuthGroup,{...this.userForm},(res)=>{
                            this.loading = false;
                            this.$message.success('添加成功');
                            this.$router.push({path:`/user/list/${this.$route.params.ruleId}`})
                        },(res)=>{
                            this.loading = false;
                            this.$message(res.msg);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// relatedGroup.vue?7fff3fca